<script setup lang="ts">
const { locale } = useI18n();

useHead({
  htmlAttrs: {
    lang: () => locale.value,
  },
});

useSeoMeta({
  ogLocale: () => getOgLocale(locale.value),
});
</script>

<template>
  <VitePwaManifest />

  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
